import { useContext } from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { MatureContext } from '../../../Context/MatureContext';
import { SessionContext } from '../../../Context';
export function useDeviationAttributes(deviation, isOwner) {
    var isUplifted = useFlag('actionbar_phase_1');
    var showMatureContent = useContext(MatureContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var isExtendedLoaded = !!deviation.extended;
    var deviationType = getDeviationType(deviation);
    var isSimple = [
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(deviationType);
    var isText = isSimple ||
        [DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(deviationType);
    if (isUplifted) {
        return {
            hasFlag: !!deviation.dailyDeviation,
            isLoveable: false,
            isCommentable: deviation.isCommentable,
            isFavouritable: !isSimple && !isOwner,
            isGroupSubmittable: isLoggedIn && !isSimple,
            isDownloadable: deviation.isDownloadable,
            // TODO: update after T39139
            isPurchasable: isExtendedLoaded && !!(deviation.extended && deviation.extended.pcp),
            isShareable: deviation.isShareable || isSimple,
            isReportable: !isOwner,
            isPrintPurchasable: !!deviation.printId &&
                (!deviation.isMature || showMatureContent) &&
                !isText,
            isEditable: isOwner,
        };
    }
    return {
        hasFlag: !!deviation.dailyDeviation,
        isLoveable: !isSimple,
        isCommentable: isExtendedLoaded && deviation.isCommentable,
        isFavouritable: !isSimple,
        isGroupSubmittable: isExtendedLoaded && !isSimple,
        isDownloadable: deviation.isDownloadable &&
            (isExtendedLoaded &&
                !!(deviation.extended && deviation.extended.download)),
        isPurchasable: isExtendedLoaded && !!(deviation.extended && deviation.extended.pcp),
        isShareable: deviation.isShareable || isSimple,
        isReportable: !isOwner,
        isPrintPurchasable: isExtendedLoaded && !!deviation.printId,
        isEditable: isExtendedLoaded && isOwner,
    };
}
//# sourceMappingURL=useDeviationAttributes.js.map